import { useState, useEffect } from 'react'
import { useLocation } from 'react-router-dom'
import axios from 'axios'
import { useAuth } from '../context/AuthContext'

const LEGAL_PATHS = ['/terms', '/privacy', '/settings']

export default function TosGate({ children }) {
  const { user, getToken } = useAuth()
  const location = useLocation()
  const [status, setStatus] = useState('loading') // loading | accepted | needs-accept | error
  const [accepting, setAccepting] = useState(false)

  const isLegalPage = LEGAL_PATHS.includes(location.pathname)

  useEffect(() => {
    if (isLegalPage || !user) { setStatus('accepted'); return }

    let cancelled = false
    ;(async () => {
      try {
        const token = await getToken()
        if (!token) { setStatus('accepted'); return } // session not yet populated; fail open
        const res = await axios.get('/api/user/tos-status', {
          headers: { Authorization: `Bearer ${token}` },
        })
        if (cancelled) return
        setStatus(res.data.accepted ? 'accepted' : 'needs-accept')
      } catch {
        if (!cancelled) setStatus('accepted') // fail open so app isn't blocked
      }
    })()
    return () => { cancelled = true }
  }, [user, getToken])

  async function handleAccept() {
    setAccepting(true)
    try {
      const token = await getToken()
      await axios.post('/api/user/tos-accept', {}, {
        headers: { Authorization: `Bearer ${token}` },
      })
      setStatus('accepted')
    } catch (err) {
      console.error('[TosGate] accept failed:', err.response?.data || err.message)
      setStatus('error')
    } finally {
      setAccepting(false)
    }
  }

  if (status === 'loading' || status === 'accepted') return children

  return (
    <div className="tos-gate">
      <div className="tos-gate__card">
        <h1 className="tos-gate__title">Updated Terms of Service</h1>
        <p className="tos-gate__desc">
          We've updated our Terms of Service. Please review the updated terms before continuing to use Verse.
        </p>
        <div className="tos-gate__link-wrap">
          <a href="/terms" className="tos-gate__link" target="_blank" rel="noopener noreferrer">
            Read the full Terms of Service
          </a>
        </div>
        {status === 'error' && (
          <p className="tos-gate__error">Something went wrong. Please try again.</p>
        )}
        <button
          className="btn btn-primary tos-gate__btn"
          onClick={handleAccept}
          disabled={accepting}
        >
          {accepting ? 'Accepting…' : 'I accept the updated Terms of Service'}
        </button>
        <p className="tos-gate__note">
          By clicking above, you agree to be bound by the updated Terms of Service effective as of the date shown in the terms. This acceptance is recorded with your account, timestamp, and IP address.
        </p>
      </div>
    </div>
  )
}
